export default function(el, binding) {
	let images = binding.value

	if(images.length > 1) {
	  el.srcset = images
	  	// .sort((a,b) => a.width - b.width)
	  	.filter(img => img.width > 0)
	    .map(img => `${img.path} ${img.width}w`)
	    .join(',')
  }

	if(images.length > 0) {
		let largest = images.reduce((prev, current) => (prev.width > current.width) ? prev : current)
    el.src = largest.path
  }

}
